import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/TaxCodesController/CreateTaxCodeController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateTaxCode({ tax, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Code: '', dec_Rate: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (tax) {
            setFormData({ vc_Code: tax.vc_Code, dec_Rate: tax.dec_Rate, vc_Description: tax.vc_Description });
        } else {
            setFormData({ vc_Code: '', dec_Rate: '', vc_Description: '' }); // Clear form data when switching to add mode
        }
    }, [tax]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (tax) {
            formData.ID = tax.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="taxCodeModal" tabIndex="-1" aria-labelledby="taxCodeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{tax ? "Edit Tax Code" : "Add Tax Code"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Tax Code:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Code" value={formData.vc_Code} onChange={handleFieldChange} />
                                        {errors.vc_Code && <div style={{ color: 'red' }}>{errors.vc_Code}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Dec Rate:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="dec_Rate" value={formData.dec_Rate} onChange={handleFieldChange} />
                                        {errors.dec_Rate && <div style={{ color: 'red' }}>{errors.dec_Rate}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Description:</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="vc_Description" value={formData.vc_Description} onChange={handleFieldChange} />

                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {tax ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateTaxCode;